module.exports = __webpack_public_path__ + "img/yishi9.4f7e64d1.jpg";